import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Header/Header";
import Home from "./Home/Home";
import Footer from "./components/Footer";
import ExecutiveBoard from "./pages/ExecutiveBoard";
import MissionBylaws from "./pages/MissionBylaws";
import Calendar from "./pages/Calendar";
import PastEvents from "./pages/PastEvents";
import Membership from "./pages/Membership";
import Gallery from "./pages/Gallery";
import AllEvents from "./pages/AllEvents";
import "./App.scss";
import "./components/Footer.scss";

function PrototypeNewApp() {
    return (
        <div className="prototype-new-app">
            <Header />
            <main className="main-content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/executive-board" element={<ExecutiveBoard />} />
                    <Route path="/mission" element={<MissionBylaws />} />
                    <Route path="/calendar" element={<Calendar />} />
                    <Route path="/past-events" element={<PastEvents />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/membership" element={<Membership />} />
                    <Route path="/all-events" element={<AllEvents />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default PrototypeNewApp;
